export default "__VITE_ASSET__CcsUfDyW__";